import requestResponseTrait from "@/shared/config/error/requestResponseTrait";
import { post } from "@/shared/config/server/HttpClient";
import sanitize from "@/shared/utils/sanitize";
import type { ResponseTraitError } from "@/types/Error/Error";

export interface GenerateContentProps {
	prompt: string;
	sessionId: string;
	lastUserMessage?: string;
	lastBotMessage?: string;
	likeOrDislikePreviousMessage?: boolean;
}

/**
 * @description Handles the request to send a prompt to gemini via socket.io
 * @param {GenerateContentProps} data
 * @returns Promise<void>
 * @throws {Error} If the request to the proxy fails
 */
export default async function generateContent(
	data: GenerateContentProps,
): Promise<{ message: string } | ResponseTraitError> {
	const likeOrDislike =
		data.likeOrDislikePreviousMessage === undefined
			? ""
			: data.likeOrDislikePreviousMessage
				? "User liked the previous message."
				: "User disliked the previous message.";
	const adaptedPrompt = await sanitize(
		`${data.prompt.trim()} /n Respond according to the user's language, You are a chatbot for the NEI Market Analytics app, an app for analyzing the cryptocurrency and stock markets. Help as much as possible with questions related to the financial market.  Text only. ${likeOrDislike}`,
	);

	const body = {
		parts: [
			{
				text: data.lastUserMessage || "",
			},
			{
				text: data.lastBotMessage || "",
			},
			{
				text: adaptedPrompt,
			},
		],
		sessionId: data.sessionId,
	};

	try {
		const response = await post("/proxy/ai", body);

		await requestResponseTrait(response);

		return await sanitize(await response.json());
	} catch (error) {
		return error as ResponseTraitError;
	}
}
